import { render } from "./EstimatedContainers.vue?vue&type=template&id=c4f120f6"
import script from "./EstimatedContainers.vue?vue&type=script&lang=js"
export * from "./EstimatedContainers.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/producer/projections/estimated_harvest/show_harvest_process.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fproducer%2Fprojections%2Festimated_harvest%2Fshow_process%2FEstimatedContainers.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/models/estimated_container.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fproducer%2Fprojections%2Festimated_harvest%2Fshow_process%2FEstimatedContainers.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__